import { hasOwnDatabase } from '@fielded/fs-api/lib/user/tools/user-db-sync'
export { hasOwnDatabase }
